const Mail = ({ width = 24, height = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00049 4C3.61978 4 2.40039 5.11929 2.40039 6.5V17.5C2.40039 18.8807 3.61978 20 5.00049 20H20.0005C21.3812 20 22.5005 18.8807 22.5005 17.5V6.5C22.5005 5.11929 21.3812 4 20.0005 4H5.00049ZM5.25723 7.44359C4.6437 7.22705 4.00039 7.6822 4.00039 8.33282C4.00039 8.73263 4.25252 9.08899 4.62953 9.22205L12.1676 11.8825C12.3829 11.9585 12.6178 11.9585 12.8332 11.8825L20.3712 9.22205C20.7483 9.08899 21.0004 8.73263 21.0004 8.33282C21.0004 7.6822 20.3571 7.22705 19.7436 7.44359L12.8332 9.88253C12.6178 9.95855 12.3829 9.95855 12.1676 9.88253L5.25723 7.44359Z"
        fill={color}
      />
    </svg>
  )
}

export default Mail
